import { NOTIFICATIONTYPE } from "./ActionTypes";

const initialState: any = <any>{
    type: NOTIFICATIONTYPE.LOADING,
    message: ''
};

export default function notificationReducer(state = initialState, action: any) {
    const { payload }  = action;
    switch (action.type) {
        case NOTIFICATIONTYPE.SUCCESS: {
            const { message } = payload;
            
            return {
                ...state,
                type: NOTIFICATIONTYPE.SUCCESS,
                message: message,
                time: + new Date()
            }
        }
        
        case NOTIFICATIONTYPE.LOADING: {
            const { message } = payload;
            
            return {
                ...state,
                type: NOTIFICATIONTYPE.LOADING,
                message: message,
                time: + new Date()
            }
        }

        case NOTIFICATIONTYPE.ERROR: {
            const { message } = payload;
            
            return {
                ...state,
                type: NOTIFICATIONTYPE.ERROR,
                message: message,
                time: + new Date()
            }
        }
        
        default:
            return state;
    }
}